import convertNode from "./convertNode";

export default function parseDocument(xmlNode) {
  return {
    type: "doc",
    content: Array.from(xmlNode.children).map(convertNode),
  };
}
